import { useContext } from 'react';

import MQ from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';
import AutomaticRecordContent from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/components/ReviewsSection/AutomaticRecordContent/AutomaticRecordContent';
import AutoHeight from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/utils/AutoHeight/AutoHeight';
import DynamicKibbleModal from '@rover/react-lib/src/pages/training/components/DynamicKibbleModal';

import type { TrainerReviewsInfo } from './FullMixedReviewsList';
import FullMixedReviewsList from './FullMixedReviewsList';
import ReviewsModalContext from './ReviewsModalContext';
import { getServiceReviewFlags } from './utils';

export type FullMixedReviewsModalProps = {
  personOpk: string;
  trainerInfo: TrainerReviewsInfo;
};

const FullMixedReviewsModal = ({
  personOpk,
  trainerInfo,
}: FullMixedReviewsModalProps): JSX.Element => {
  const isMobile = useMatchMedia(MQ.XS_DOWN.getBreakpointString());
  const {
    selectedReviewIndex,
    isModalForAutomaticRecord,
    closeReviewsModal,
    toggleAutomaticRecordModal,
  } = useContext(ReviewsModalContext);

  // if there is a scrollIndex selected, we want to show the modal
  const modalOpen = selectedReviewIndex >= 0;
  const fullList = !isMobile ? !isModalForAutomaticRecord : true;
  const { shouldShowFilter } = getServiceReviewFlags(trainerInfo.trainerInsights);

  return (
    <>
      <DynamicKibbleModal
        isOpen={modalOpen}
        onRequestClose={closeReviewsModal}
        mobileProps={{ isFullHeight: true, animationDirection: 'horizontal' }}
      >
        <AutoHeight>
          {isModalForAutomaticRecord &&
            modalOpen &&
            (isMobile ? (
              <DynamicKibbleModal isOpen onRequestClose={toggleAutomaticRecordModal}>
                <AutomaticRecordContent onClose={toggleAutomaticRecordModal} />
              </DynamicKibbleModal>
            ) : (
              <AutomaticRecordContent onBack={toggleAutomaticRecordModal} />
            ))}
          {fullList && (
            <FullMixedReviewsList
              personOpk={personOpk}
              scrollIndex={selectedReviewIndex}
              trainerInfo={trainerInfo}
              onLearnMore={toggleAutomaticRecordModal}
              onClickClose={closeReviewsModal}
              shouldShowFilter={shouldShowFilter}
            />
          )}
        </AutoHeight>
      </DynamicKibbleModal>
      <DynamicKibbleModal
        isOpen={isModalForAutomaticRecord && !modalOpen}
        onRequestClose={toggleAutomaticRecordModal}
      >
        <AutomaticRecordContent onClose={toggleAutomaticRecordModal} />
      </DynamicKibbleModal>
    </>
  );
};

export default FullMixedReviewsModal;
